import { IconCloudUpload, IconReload, IconX, IconTrash, IconDeviceFloppy, IconCamera, IconPhoto } from '@tabler/icons-react';
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { CurrencyInput } from '../../utils/CurrencyInput';
import { DinamicTitle } from '../../utils/DinamicTitle';
import imageCompression from 'browser-image-compression';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

function TambahBarang() {
  DinamicTitle('Tambah Barang || Komaladewi');
  const navigate = useNavigate();
  const [kategori, setKategori] = useState([]);
  const [jenis_kategori_id, setJeniKategoriId] = useState('');
  const [berat, setBerat] = useState('');
  const [karat, setKarat] = useState('');
  // const [cabang_id, setCabangId] = useState('');
  const [cabang, setCabang] = useState([]);
  const [jenisKategori, setJenisKategori] = useState([]);
  const [harga_modal, setHargaModal] = useState(0);
  const [gambar1, setGambar1] = useState('');
  const [nomor_rak, setNomerRak] = useState('');
  const [selectImage, setSelectImage] = useState([]);
  const [loading, setLoading] = useState(false);

  const [kategoriId, setKategoriId] = useState('');

  const isFormValid = useMemo(() => {
    return (
      kategoriId !== '' &&
      jenis_kategori_id !== '' &&
      berat !== '' &&
      karat !== '' &&
      nomor_rak !== '' &&
      Number(harga_modal) > 0 &&
      gambar1 !== ''
    );
  }, [kategoriId, jenis_kategori_id, berat, karat, nomor_rak, harga_modal, gambar1]);

  useEffect(() => {
    async function getCabang() {
      await http
        .get('/cabang', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          }
        });
    }
    getCabang();
  }, []);

  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          // console.log('res::: ', res);
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, [navigate]);

  function resetForm() {
    setJeniKategoriId('');
    setBerat('');
    // setCabangId('');
    setKarat('');
    setHargaModal(0);
    setGambar1('');
    setNomerRak('');
    setSelectImage([]);
    setKategoriId('');
    setJenisKategori([]);
  }

  useEffect(() => {
    const regex = /^\d*\.?\d{0,3}$/;
    if (berat && !regex.test(berat)) {
      setBerat(berat.slice(0, -1));
    }
  }, [berat]);

  const handleImageChange = async (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);

    if (selectImage.length < 1) {
      const file = selectedFiles[0];

      // Options for image compression
      const options = {
        maxSizeMB: 1, // Maximum size in MB
        maxWidthOrHeight: 1024, // Maximum width or height
        useWebWorker: true, // Use web worker for better performance
      };

      try {
        const compressedFile = await imageCompression(file, options);
        console.log('Ukuran file setelah kompresi:', (compressedFile.size / 1024).toFixed(2), 'KB');

        const reader1 = new FileReader();
        reader1.addEventListener('load', function () {
          setGambar1(reader1.result.split(',')[1]);
        });
        reader1.readAsDataURL(compressedFile);

        const compressedImageURL = URL.createObjectURL(compressedFile);
        setSelectImage([compressedImageURL]);
      } catch (error) {
        console.error('Error compressing image:', error);
      }
    } else {
      const imagesArray = selectedFilesArray.map((file) => {
        return URL.createObjectURL(file);
      });
      setSelectImage(imagesArray);
    }

    // FOR BUG IN CHROME
    event.target.value = '';
  };

  function deleteHandler(image) {
    setSelectImage(selectImage.filter((e) => e !== image));
    URL.revokeObjectURL(image);
    setGambar1('');
  }

  async function handleSubmitItem(e) {
    e.preventDefault();
    if (!isFormValid) {
      toast.warning('Lengkapi semua data wajib termasuk foto barang sebelum menyimpan.', { autoClose: 800 });
      return;
    }
    if (harga_modal !== 0) {
      try {
        setLoading(true);
        const response = await http.post(
          `/item`,
          {
            jenis_kategori_id,
            berat,
            karat,
            nomor_rak,
            harga_modal,
            // cabang_id,
            gambar1,
          },
          {
            headers: { Authorization: getAuthorizationHeader() },
          },
        );
        toast.success('Data berhasil disimpan', { autoClose: 600 });
        setLoading(false);
        resetForm();
        return response.data;
      } catch (error) {
        toast.warning('Silahkan ganti gambar', { autoClose: 600 });
        if (error.response?.status === 401) {
          navigate('/login');
        } else if (error.response?.status === 422) {
          toast.warning('Lengkapi input data', { autoClose: 600 });
        } else if (error.code === 'ERR_NETWORK') {
          toast.warning('Periksa jaringan internet', { autoClose: 600 });
        }
      }
    } else {
      toast.error('Input harga modal tidak boleh kosong', { autoClose: 600 });
    }
    setLoading(false);
  }

  async function selectJenisKategori(id) {
    setKategoriId(id);
    setJeniKategoriId('');
    await http
      .get(`/jenis/kategori/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setJenisKategori(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const karatOption = [
    { karat: 16 },
    { karat: 17 },
    { karat: 18 },
    { karat: 19 },
    { karat: 20 },
    { karat: 21 },
    { karat: 22 },
    { karat: 23 },
    { karat: 24 },
  ];

  const bakiOption = [
    { baki: 1 }, { baki: 2 }, { baki: 3 }, { baki: 4 }, { baki: 5 },
    { baki: 6 }, { baki: 7 }, { baki: 8 }, { baki: 9 }, { baki: 10 },
    { baki: 11 }, { baki: 12 }, { baki: 13 }, { baki: 14 }, { baki: 15 },
    { baki: 16 }, { baki: 17 }, { baki: 18 }, { baki: 19 }, { baki: 20 },
  ];

  return (
    <Layouts
      compFilter={
        <button
          onClick={() => window.location.reload()}
          className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 p-2 text-slate-700 dark:text-slate-200 rounded-md transition"
          title="Refresh halaman"
        >
          <IconReload />
        </button>
      }
    >
      <div className="mx-auto max-w-4xl">
        <div className="bg-white dark:bg-slate-900 sm:shadow-sm sm:border border-slate-200 dark:border-slate-800 sm:rounded-xl">
          {/* Header */}
          <div className="px-4 py-4 sm:px-6 border-b border-slate-200 dark:border-slate-800">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">Tambah Barang</h2>
            <p className="text-sm sm:text-sm text-slate-500 dark:text-slate-400 mt-1">
              Lengkapi semua field yang diperlukan
            </p>
          </div>

          <div className="px-4 py-5 sm:p-6 pb-36 sm:pb-6">
            <form onSubmit={handleSubmitItem} className="space-y-6">

              {/* === Section: Kategori === */}
              <div className="space-y-5">
                <div className="relative">
                  <select
                    value={kategoriId}
                    onChange={(e) => { if (e.target.value) selectJenisKategori(e.target.value); else { setKategoriId(''); setJenisKategori([]); setJeniKategoriId(''); } }}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Kategori</option>
                    {kategori.map((item) => (
                      <option key={item.id} value={item.id}>{item.nama_kategori}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Kategori</label>
                </div>

                <div className="relative">
                  <select
                    value={jenis_kategori_id}
                    onChange={(e) => setJeniKategoriId(e.target.value)}
                    required
                    disabled={!kategoriId}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer disabled:bg-slate-50 dark:disabled:bg-slate-900 disabled:text-slate-400 dark:disabled:text-slate-600 disabled:cursor-not-allowed appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Jenis Kategori</option>
                    {jenisKategori.map((item) => (
                      <option key={item.id} value={item.id}>{item.nama_jenis}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Jenis Kategori</label>
                </div>
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}

              {/* === Section: Detail Barang === */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <select
                    value={nomor_rak}
                    onChange={(e) => setNomerRak(Number(e.target.value))}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih Baki</option>
                    {bakiOption.map((item) => (
                      <option key={item.baki} value={item.baki}>{item.baki}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Nomor BAKI</label>
                </div>

                <div className="relative">
                  <select
                    value={karat}
                    onChange={(e) => setKarat(Number(e.target.value))}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500 cursor-pointer appearance-none"
                    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
                  >
                    <option value="">Pilih</option>
                    {karatOption.map((item) => (
                      <option key={item.karat} value={item.karat}>{item.karat}</option>
                    ))}
                  </select>
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Karat</label>
                </div>
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <input
                    placeholder='Contoh: 2.350'
                    type="number"
                    step="0.001"
                    inputMode="decimal"
                    id="berat"
                    autoComplete="off"
                    value={berat}
                    onChange={(e) => setBerat(e.target.value)}
                    required
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Berat (gram)</label>
                  {/* <p className="text-xs text-slate-400 mt-1.5">Input sesuai format</p> */}
                </div>

                {/* === Section: Harga === */}
                <div className="relative">
                  <CurrencyInput
                    name="harga_modal"
                    value={harga_modal}
                    autoComplete="off"
                    onChange={(value) => setHargaModal(() => value)}
                    className="w-full h-14 sm:h-12 border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 pt-4 pb-1 sm:pt-3.5 sm:pb-1.5 text-base sm:text-sm dark:text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500/50 focus:border-amber-500"
                  />
                  <label className="absolute -top-2.5 left-3 bg-white dark:bg-slate-900 px-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">Harga Modal / Gram</label>
                </div>
              </div>

              {/* === Divider === */}
              {/* <div className="border-t border-slate-100"></div> */}

              {/* === Section: Foto === */}
              <div className="bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-800 p-4 sm:p-5 rounded-lg">
                <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">Foto Barang (1 foto)</p>
                {/* <p className="text-xs text-slate-400 mt-0.5">Format: JPG/PNG/WEBP</p> */}

                {selectImage.length > 0 && (
                  <div className="mt-4 flex items-center gap-3 overflow-x-auto pb-2">
                    {selectImage.map((image, index) => (
                      <div key={index} className="relative flex-shrink-0">
                        <button
                          type="button"
                          onClick={() => deleteHandler(image)}
                          className="absolute -top-2 -right-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-full p-1.5 shadow-md z-10 active:scale-90 transition-transform"
                        >
                          <IconX width={16} className="dark:text-slate-200" />
                        </button>
                        <PhotoProvider>
                          <PhotoView src={image}>
                            <img
                              className="h-24 w-24 sm:h-20 sm:w-20 rounded-lg border border-slate-200 dark:border-slate-700 object-cover bg-white dark:bg-slate-900 cursor-pointer"
                              src={image}
                              alt="Preview"
                              title="Klik untuk memperbesar gambar"
                            />
                          </PhotoView>
                        </PhotoProvider>
                      </div>
                    ))}
                  </div>
                )}

                <div className="mt-4 grid grid-cols-2 gap-3">
                  <label className="flex items-center justify-center gap-2 h-14 sm:h-11 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border-2 border-amber-200 dark:border-amber-800/50 hover:bg-amber-100 dark:hover:bg-amber-900/30 active:bg-amber-200 dark:active:bg-amber-900/40 text-sm font-semibold cursor-pointer transition rounded-lg">
                    <IconCamera className="w-5 h-5" />
                    Kamera
                    <input
                      type="file"
                      onChange={handleImageChange}
                      accept="image/*"
                      capture="environment"
                      className="hidden"
                    />
                  </label>
                  <label className="flex items-center justify-center gap-2 h-14 sm:h-11 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-2 border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 active:bg-slate-100 dark:active:bg-slate-600 text-sm font-semibold cursor-pointer transition rounded-lg">
                    <IconPhoto className="w-5 h-5" />
                    Galeri
                    <input
                      type="file"
                      onChange={handleImageChange}
                      accept="image/png,image/jpeg,image/webp"
                      className="hidden"
                    />
                  </label>
                </div>
              </div>

              <div className="fixed sm:static bottom-0 left-0 right-0 p-4 sm:p-0 bg-white dark:bg-slate-900 sm:bg-transparent border-t sm:border-t-0 border-slate-200 dark:border-slate-800 sm:border-transparent shadow-[0_-4px_12px_rgba(0,0,0,0.08)] sm:shadow-none z-40 sm:z-auto">
                <div className="max-w-4xl mx-auto">
                  <button
                    type="submit"
                    disabled={loading || !isFormValid}
                    className="w-full h-14 sm:h-11 px-6 text-base sm:text-sm font-bold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 active:from-amber-600 active:to-amber-700 rounded-xl sm:rounded-lg shadow-lg shadow-amber-500/20 disabled:from-slate-300 disabled:to-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed disabled:shadow-none transition-all flex items-center justify-center gap-2"
                  >
                    <IconDeviceFloppy className="w-5 h-5" />
                    {loading ? 'Proses...' : 'Simpan'}
                  </button>
                </div>
              </div>

              {loading && (
                <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
                  <div className="w-12 h-12 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default TambahBarang;
